import { Pipe, PipeTransform } from '@angular/core';
import { QStatus } from '../synchronization.model';

@Pipe({
  name: 'queueStatusClass',
  standalone: true
})
export class QueueStatusClassPipe implements PipeTransform {
  // The null branch below already existed; the signature just never admitted it.
  transform(status: QStatus | undefined | null): string {
    if (status === undefined || status === null) return 'bg-secondary';
    
    switch (status) {
      case QStatus.Done:
        return 'bg-success';
      case QStatus.DoneWithWarnings:
      case QStatus.Warnings:
        return 'bg-warning';
      case QStatus.DoneWithErrors:
      case QStatus.Failed:
      case QStatus.SystemFailed:
        return 'bg-danger';
      case QStatus.Cancelled:
        return 'bg-secondary';
      case QStatus.Executing:
      case QStatus.PrepareExecute:
      case QStatus.ReadDataExecute:
      case QStatus.SyncDataExecute:
      case QStatus.PreSynchronizationExecute:
      case QStatus.PostSynchronizationExecute:
        return 'bg-primary';
      case QStatus.Waiting:
      case QStatus.Paused:
      case QStatus.Queued:
        return 'bg-info';
      default:
        return 'bg-secondary';
    }
  }
}
